import { UserId } from '@business/entities/account';
import { Endpoint } from '../endpoint';
import { TopMenuId, TopMenuResponse, TopMenuSorting, UpdateUserPermissionRequest } from '@business/entities/top_menu';

export function fetchPermissions(id: UserId) {
  return Endpoint.get<TopMenuResponse[]>(`@makh/user-permission/${id}`);
}

export function patchPermissions(params: UpdateUserPermissionRequest) {
  return Endpoint.patch<TopMenuResponse[]>(`@makh/user-permission`, { params });
}
